"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ATLOptionBase_1 = require("../atoms/ATLOptionBase");
var react_native_1 = require("react-native");
var native_1 = __importDefault(require("styled-components/native"));
var ATLAtomLabel_1 = require("../atoms/ATLAtomLabel");
var ThemeProvider_1 = require("../theme/ThemeProvider");
var defaultProps = {
    complementary: false,
    radioButtonProps: {}
};
// STYLED COMPONENTS ---------------------------------------------------------------------------------------------------
exports.OptionWrapper = native_1.default(react_native_1.TouchableOpacity)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: ", "px\n          ", "px;\n"], ["\n  margin: ", "px\n          ", "px;\n"
    // COMPONENT -----------------------------------------------------------------------------------------------------------
])), function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.verticalItemMargin || atlTheme.SpacingAtomic;
}, function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.horizontalItemMargin || atlTheme.SpacingInputMarginHorizontal;
});
// COMPONENT -----------------------------------------------------------------------------------------------------------
exports.ATLRadioGroup = function (_a) {
    var selectedItem = _a.selectedItem, onChange = _a.onChange, radioButtonsList = _a.radioButtonsList, title = _a.title, complementary = _a.complementary, horizontalItemMargin = _a.horizontalItemMargin, verticalItemMargin = _a.verticalItemMargin, radioButtonProps = _a.radioButtonProps, titleLabelBaseProps = _a.titleLabelBaseProps;
    var theme = ThemeProvider_1.useTheme();
    var onPressItem = react_1.useCallback(function (id) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (selectedItem !== id)
                onChange && onChange(id);
            return [2 /*return*/];
        });
    }); }, [selectedItem, onChange]);
    var renderTitle = function () { return (react_1.default.createElement(ATLAtomLabel_1.ATLAtomLabel, __assign({ fontFamily: theme.FontFamilySystem, fontSize: theme.FontSizeBody, fontWeight: theme.FontWeightNormal, lineHeight: theme.LineHeightBase, multilineLimit: theme.MultilineLimitBody, textColor: complementary ? theme.ColorComplementary1 : theme.ColorHighContrast, opacity: 1 }, titleLabelBaseProps), title || '')); };
    // Renders RadioGroup item
    var renderRadioItem = react_1.useMemo(function () { return (radioButtonsList.map(function (r) {
        return (react_1.default.createElement(exports.OptionWrapper, __assign({ horizontalMargin: horizontalItemMargin, verticalMargin: verticalItemMargin, key: r.id }, radioButtonProps),
            react_1.default.createElement(ATLOptionBase_1.ATLOptionBase, __assign({ key: r.id, value: selectedItem === r.id, text: r.text, rightText: r.rightText, onChange: function () { return onPressItem(r.id); }, complementary: complementary }, radioButtonProps))));
    })); }, [radioButtonsList, selectedItem]);
    // Returns complete ATLRadioGroup
    return (react_1.default.createElement(react_native_1.View, null,
        react_1.default.createElement(exports.OptionWrapper, { horizontalMargin: horizontalItemMargin, verticalMargin: verticalItemMargin }, title && renderTitle()),
        renderRadioItem));
};
exports.ATLRadioGroup.defaultProps = defaultProps;
exports.ATLRadioGroup.displayName = 'ATLRadioGroup';
var templateObject_1;
